module.exports = __webpack_public_path__ + "static/media/referee.091779c5.svg";